import { Typography } from '@core/ui';
import styled from 'styled-components';

export const Notes = styled('div')`
  margin-top: ${({ theme: { spacing } }) => spacing(6)};
  ${Typography.Subheading1} {
    margin-bottom: ${({ theme: { spacing } }) => spacing(4)};
  }
`;
